export const SHOW_EMAIL_VERIFICATION_FORM_FAILED = 'SHOW_EMAIL_VERIFICATION_FORM_FAILED'
export const SHOW_EMAIL_VERIFICATION_FORM_REQUEST = 'SHOW_EMAIL_VERIFICATION_FORM_REQUEST'
export const SHOW_EMAIL_VERIFICATION_FORM_SUCCEEDED = 'SHOW_EMAIL_VERIFICATION_FORM_SUCCEEDED'

export const SEND_NEW_EMAIL_VERIFICATION_FAILED = 'SEND_NEW_EMAIL_VERIFICATION_FAILED'
export const SEND_NEW_EMAIL_VERIFICATION_REQUEST = 'SEND_NEW_EMAIL_VERIFICATION_REQUEST'
export const SEND_NEW_EMAIL_VERIFICATION_SUCCEEDED = 'SEND_NEW_EMAIL_VERIFICATION_SUCCEEDED'
